// extracted by mini-css-extract-plugin
module.exports = {"container":"i_JQ","image-wrapper":"i_JR","icon-wrapper":"i_JS","loader":"i_JT","icon":"i_JU"};